import { BehaviorSubject, Observable, Subject } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ConfigService } from "./config.service";
import { SpinnerService } from "../components/spinner/spinner.service";

export interface LoginResponse {
  accountFlags: number[];
  token: string;
  firstname: string;
  lastname: string;
  email: string;
  phone: string;
  memberId: string;
  vitaPointsBalance: number;
  customerRank: number;
  billingAddress: Address;
  shippingAddress: Address;
  memberlevel: string;
  isPremierMember: boolean;
  isAffiliate: boolean;
  isItbo: boolean;
  returnUrl?: string;
}

export interface Address {
  addressName: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  postalCode: string;
  countryId: number;
  isDefaultBillingAddress: boolean;
  isDefaultShippingAddress: boolean;
}

export interface NewUser {
  contactInfo: ContactInfo;
  referralId: number;
  password: string;
  shippingAddress: Address;
  billingAddress: Address;
}

export interface ContactInfo {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
}

@Injectable({
  providedIn: "root",
})
export class UserService {
  private _logOutSubject: Subject<boolean> = new Subject();

  get currentUser(): LoginResponse {
    return JSON.parse(localStorage.getItem("currentUser"));
  }

  get logOutSubject(): Subject<boolean> {
    return this._logOutSubject;
  }

  private loginChangedSubject = new Subject();
  public loginChanged$ = this.loginChangedSubject.asObservable();

  sso: any;
  isLoggedIn = false;
  public user: any;
  private token: any;

  constructor(
    private configService: ConfigService,
    private httpClient: HttpClient,
    private spinnerService: SpinnerService
  ) {
    this.startListenToEvents();
  }

  startListenToEvents() {
    window.addEventListener("sso:ready", (event) => {
      this.sso = window["sso"];
      console.log(this.sso);
      if (this.sso) {
        window.addEventListener("sso:login", (event) => {
          this.user = this.sso.profile;

          if (this.user) {
            this.token = this.sso.token;
            this.setCurrentUser(this.user);
            this.isLoggedIn = true;
            this.loginChangedSubject.next();
            console.log(this.user);

            this.spinnerService.hideSpinner();
          }
        });

        window.addEventListener("sso:logout", (event) => {
          this.loginChangedSubject.next();
          this.spinnerService.hideSpinner();
          this.isLoggedIn = false;
          this.user = null;
        });

        window.addEventListener("session:timeout", () => {
          //this.logOut();
          this.spinnerService.hideSpinner();
        });
      }
    });
  }

  openLoginModal(redirectURL?) {
    this.sso.openLoginModal(redirectURL);
  }

  closeLoginModal() {
    this.sso.closeLoginModal();
  }

  createNewUser(body: NewUser): Observable<any> {
    return this.httpClient.post<any>(
      this.configService.getConfiguration().apiUrlData.smartPublicCustomer +
        "CreateNewCustomer",
      body
    );
  }

  setCurrentUser(user: LoginResponse): void {
    localStorage.setItem("currentUser", JSON.stringify(user));
    localStorage.setItem("countryId", this.user.shippingAddress.countryId);
  }

  // getCurrentUserByToken(token: string): Observable<LoginResponse> {
  //   return this.httpClient.get<LoginResponse>(
  //     this.configService.getConfiguration().apiUrlData.global + "profile",
  //     { headers: { Authorization: `bearer ${token}` } }
  //   );
  // }
}
